// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"accordionStyle__wrapper__Vi7KQ","header":"accordionStyle__header__x-peA","headerText":"accordionStyle__headerText__npLv1","content":"accordionStyle__content__pozml"};